import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { SnackbarRender } from './snackbarRender.component';
import { selectActiveSnackbar } from '../../../modules/snackbar/snackbar.selectors';

const mapStateToProps = createStructuredSelector({
  activeSnackbar: selectActiveSnackbar,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(SnackbarRender);
